// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 21H2V19H22V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 16H2V14H22V16Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.90039 3.69434L4.63965 3.91016L4.69629 3.92578C5.17839 3.34079 5.89949 2.86718 6.83301 2.86719C7.76096 2.86744 8.50018 3.30634 8.99902 3.91602L9.03711 3.90625L9.83301 3.68457V2.33105H11.833V5.20605L9.78613 5.77344C9.79567 5.83841 9.80302 5.9036 9.80957 5.96875H11.833V7.96875H9.82715C9.81568 8.13221 9.78299 8.29643 9.73828 8.45996L11.833 9.20312V11.7969H9.83301V10.6152L8.96973 10.3096L8.63574 10.1904C8.17766 10.5886 7.56594 10.909 6.83301 10.9092C6.09762 10.9092 5.48407 10.5875 5.02539 10.1875L4.70801 10.3057L3.83301 10.6279V11.8184H1.83301V9.23535L3.92676 8.45996C3.88206 8.29649 3.85034 8.13216 3.83887 7.96875H1.83301V5.96875H3.85645C3.86344 5.90324 3.86942 5.83721 3.87988 5.77148L1.90039 5.19727V2.33105H3.90039V3.69434Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 11H14V9H22V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 6H14V4H22V6Z"}}]};

const ListBugFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'list-bug-filled',
    ref,
    icon: element,
  },
));

ListBugFilledIcon.displayName = 'ListBugFilledIcon';

export default ListBugFilledIcon;
